import EditPropertyContainer from './EditPropertyContainer';

export default EditPropertyContainer;
